import React, { useState, useEffect, useRef } from "react";
import {
  FaAngleDown,
  FaArrowRight,
  FaArrowUpRightFromSquare,
  FaBarsStaggered,
  FaXmark,
} from "react-icons/fa6";
import { MdCelebration } from "react-icons/md";
import logo from "../../../assets/images/logo.png";
import { useNavigate } from "react-router-dom";
import { FiShoppingBag } from "react-icons/fi";

const Header = () => {
  const navigate = useNavigate();

  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const headerRef = useRef(null);
  const mobileMenuRef = useRef(null);

  const toggleDropdown = (menuName) => {
    setActiveDropdown(activeDropdown === menuName ? null : menuName);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    setActiveDropdown(null);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        headerRef.current &&
        !headerRef.current.contains(event.target) &&
        !(mobileMenuRef.current && mobileMenuRef.current.contains(event.target))
      ) {
        setActiveDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isMobileMenuOpen]);

  const generalPagesData = [
    { name: "About", link: "/about-us" },
    { name: "Contact Us", link: "/contact-us" },
    { name: "Pricing", link: "/pricing" },
    { name: "Terms of Service", link: "/terms-of-service" },
    { name: "Privacy Policy", link: "/privacy-policy" },
  ];

  // const maintenancePagesData = [
  //   { name: "Coming Soon", link: "/" },
  //   { name: "Error 404", link: "/" },
  //   { name: "Error 500", link: "/" },
  //   { name: "Under Maintenance", link: "/" },
  // ];

  const externalPagesData = [
    { name: "How-to Videos", link: "/how-to-videos" },
    { name: "Help Docs", link: "/documentation" },
    { name: "Frequently Asked Questions", link: "/frequently-asked-questions" },
  ];

  const handleNavigateHome = () => {
    window.location.href = "https://b2b.selzor.com/";
  };

  return (
    <div className="bg-[#dbf4f1]">
      <header
        ref={headerRef}
        className="relative w-full py-3 px-6 md:px-12 lg:px-20 rounded-full flex items-center justify-between mx-auto max-w-[1500px]"
      >
        {}
        <div className="flex items-center space-x-2">
          <a href="/">
            <img src={logo} className="w-[112px] lg:w-[140px] h-auto " alt="" />
          </a>
        </div>

        {}
        <nav className="hidden lg:flex items-center space-x-8 px-8 py-3">
          <a href="/" className="text-gray-600 hover:text-gray-700 font-medium">
            Home
          </a>

          {}
          <div className="relative">
            <button
              onClick={() => toggleDropdown("product")}
              className="flex items-center text-gray-600 hover:text-gray-700 font-medium"
            >
              Product
              <FaAngleDown
                className={`ml-1 h-4 w-4 transform transition-transform ${
                  activeDropdown === "product" ? "rotate-180" : ""
                }`}
              />
            </button>
            {activeDropdown === "product" && (
              <div className="absolute left-28 -translate-x-1/2 mt-3 w-60 bg-white rounded-lg shadow-lg py-2 z-40">
                <div className="flex flex-col">
                  <a
                    href="/features"
                    className="px-4 py-2 text-gray-950 hover:text-gray-500 text-start"
                  >
                    Features
                  </a>
                </div>
              </div>
            )}
          </div>

          <div className="relative">
            <button
              onClick={() => toggleDropdown("solutions")}
              className="flex items-center text-gray-600 hover:text-gray-700 font-medium"
            >
              Solutions
              <FaAngleDown
                className={`ml-1 h-4 w-4 transform transition-transform ${
                  activeDropdown === "solutions" ? "rotate-180" : ""
                }`}
              />
            </button>
            {activeDropdown === "solutions" && (
              <div className="absolute left-40 -translate-x-1/2 mt-3 w-80 bg-white rounded-lg shadow-lg py-2 z-40">
                <div className="flex flex-col">
                  <a
                    href="/field-order-taking-for-sales-reps"
                    className="px-4 py-2 text-gray-950 hover:text-gray-500 text-start"
                  >
                    Field Order Taking for Sales Reps
                  </a>
                  <a
                    href="/self-ordering-for-b2b-customers"
                    className="px-4 py-2 text-gray-950 hover:text-gray-500 text-start"
                  >
                    Self Ordering for B2B Customers
                  </a>
                  <a
                    href="/order-management-for-businesses"
                    className="px-4 py-2 text-gray-950 hover:text-gray-500 text-start"
                  >
                    Order Management Software
                  </a>
                  <a
                    href="/features"
                    className="px-4 py-2 text-gray-950 hover:text-gray-500 text-start"
                  >
                    Mobile Product catalogue with Ordering
                  </a>
                </div>
              </div>
            )}
          </div>

          <a
            href="/why-selzor"
            className="text-gray-600 hover:text-gray-700 font-medium"
          >
            Why Selzor{" "}
          </a>

          <a
            href="/pricing"
            className="text-gray-600 hover:text-gray-700 font-medium"
          >
            Plans & Pricing
          </a>

          {}
          <div className="relative">
            <button
              onClick={() => toggleDropdown("pages")}
              className="flex items-center text-gray-600 hover:text-gray-700 font-medium"
            >
              Resources
              <FaAngleDown
                className={`ml-1 h-4 w-4 transform transition-transform ${
                  activeDropdown === "pages" ? "rotate-180" : ""
                }`}
              />
            </button>
            {activeDropdown === "pages" && (
              <div className="absolute left-40 -translate-x-1/2 mt-3 w-80 bg-white rounded-lg shadow-lg py-2 z-40">
                <div className="flex flex-col">
                  {/* <a href="/how-to-videos" className="px-4 py-2 text-gray-950 hover:text-gray-500 text-start">How-to Videos</a> */}
                  <a
                    href="/frequently-asked-questions"
                    className="px-4 py-2 text-gray-950 hover:text-gray-500 text-start"
                  >
                    Frequently Asked Questions
                  </a>
                </div>
              </div>
            )}
          </div>

          {}
          <div className="relative">
            <a
              href="/documentation"
              className="flex items-center text-gray-600 hover:text-gray-700 font-medium"
            >
              Docs
              <FaArrowUpRightFromSquare className="ml-1 h-3 w-3" />
            </a>
          </div>
        </nav>

        {}
        <div className="flex items-center space-x-3">
          {}
          {/* <button className="bg-[#b9ece6] p-3 rounded-full hover:bg-[#8cded4]">
          <IoSettingsOutline className="h-6 w-6 text-gray-600" />
        </button>
        {}
        <button className="bg-[#b9ece6] p-3 rounded-full hover:bg-[#8cded4]">
          <FaGithub className="h-6 w-6 text-gray-600" />
        </button> */}
          {}
          <button
            className="hidden lg:flex items-center gap-2 bg-[#1a9588] text-white px-6 py-3 rounded-full font-medium hover:bg-[#28b5a6] hover:shadow-lg hover:scale-105 transition-all duration-200 ease-in-out"
            onClick={handleNavigateHome}
          >
            <FiShoppingBag className="text-xl" />
            Become A Seller
          </button>
          {}
          <button
            className="lg:hidden p-3 rounded-full text-gray-600 hover:bg-[#b9ece6] "
            onClick={toggleMobileMenu}
          >
            {isMobileMenuOpen ? (
              <FaXmark className="h-6 w-6" />
            ) : (
              <FaBarsStaggered className="h-6 w-6" />
            )}
          </button>
        </div>

        {}
        {isMobileMenuOpen && (
          <div
            ref={mobileMenuRef}
            className="fixed inset-0 bg-white z-50 flex flex-col items-start p-6 transform transition-transform duration-300 ease-in-out lg:hidden overflow-y-auto"
          >
            {}
            <button
              className="self-end p-3 rounded-full text-gray-600 hover:bg-[#b9ece6]"
              onClick={toggleMobileMenu}
            >
              <FaXmark className="h-6 w-6" />
            </button>

            {}
            <nav className="flex flex-col space-y-4 w-full mt-8 text-start">
              {}
              <a
                href="/"
                className="text-gray-600 hover:text-gray-700 font-medium text-lg py-2 border-b border-gray-100"
                onClick={toggleMobileMenu}
              >
                Home
              </a>

              {}
              <div className="relative w-full">
                <button
                  onClick={() => toggleDropdown("product")}
                  className="flex items-center justify-between w-full text-gray-600 hover:text-gray-700 font-medium text-lg py-2 border-b border-gray-100"
                >
                  Product
                  <FaAngleDown
                    className={`ml-1 h-5 w-5 transform transition-transform ${
                      activeDropdown === "product" ? "rotate-180" : ""
                    }`}
                  />
                </button>
                {activeDropdown === "product" && (
                  <div className="flex flex-col space-y-2 mt-3 pl-4 pb-2 border-b border-gray-100">
                    <a
                      href="/features"
                      className="text-gray-700 hover:text-gray-500"
                      onClick={toggleMobileMenu}
                    >
                      Features
                    </a>
                  </div>
                )}
              </div>

              {}
              <div className="relative w-full">
                <button
                  onClick={() => toggleDropdown("solutions")}
                  className="flex items-center justify-between w-full text-gray-600 hover:text-gray-700 font-medium text-lg py-2 border-b border-gray-100"
                >
                  Solutions
                  <FaAngleDown
                    className={`ml-1 h-5 w-5 transform transition-transform ${
                      activeDropdown === "solutions" ? "rotate-180" : ""
                    }`}
                  />
                </button>
                {activeDropdown === "solutions" && (
                  <div className="flex flex-col space-y-2 mt-3 pl-4 pb-2 border-b border-gray-100">
                    <a
                      href="/field-order-taking-for-sales-reps"
                      className="text-gray-700 hover:text-gray-500"
                      onClick={toggleMobileMenu}
                    >
                      {/* Field Order Taking for Sales Reps */}
                      Buyer Self-Ordering for B2B
                    </a>
                    <a
                      href="/self-ordering-for-b2b-customers"
                      className="text-gray-700 hover:text-gray-500"
                      onClick={toggleMobileMenu}
                    >
                      {/* Self Ordering for B2B Customers */}
                      Sales Enablement for Field Teams
                    </a>
                    <a
                      href="/order-management-for-businesses"
                      className="text-gray-700 hover:text-gray-500"
                      onClick={toggleMobileMenu}
                    >
                      Order Management for B2B Sellers
                    </a>
                    <a
                      href="/features"
                      className="text-gray-700 hover:text-gray-500"
                      onClick={toggleMobileMenu}
                    >
                     Mobile Product Catalog with Pricing Control
                    </a>
                    <a
                      href="/features"
                      className="text-gray-700 hover:text-gray-500"
                      onClick={toggleMobileMenu}
                    >
                     Distributor & Dealer Order Management
                    </a>
                  </div>
                )}
              </div>

              {}
              <a
                href="/why-selzor"
                className="text-gray-600 hover:text-gray-700 font-medium text-lg py-2 border-b border-gray-100"
                onClick={toggleMobileMenu}
              >
                Why Selzor
              </a>

              {}
              <a
                href="/pricing"
                className="text-gray-600 hover:text-gray-700 font-medium text-lg py-2 border-b border-gray-100"
                onClick={toggleMobileMenu}
              >
                Plans & Pricing
              </a>

              {}
              <div className="relative w-full">
                <button
                  onClick={() => toggleDropdown("pages")}
                  className="flex items-center justify-between w-full text-gray-600 hover:text-gray-700 font-medium text-lg py-2 border-b border-gray-100"
                >
                  Resources
                  <FaAngleDown
                    className={`ml-1 h-5 w-5 transform transition-transform ${
                      activeDropdown === "pages" ? "rotate-180" : ""
                    }`}
                  />
                </button>
                {activeDropdown === "pages" && (
                  <div className="flex flex-col space-y-2 mt-3 pl-4 pb-2 border-b border-gray-100">
                    <div className="p-4 bg-purple-50 rounded-lg flex flex-col items-center justify-center text-start mb-2">
                      <h3 className="font-semibold text-black text-start mb-1 flex bg-white rounded-full px-4 py-1.5 items-center text-base">
                        <MdCelebration className="pr-2 w-6 h-6" />
                        SaasAble UI Kit
                      </h3>
                      <p className="text-black text-base font-semibold">
                        Kickstart your project with pre-built essentials pages.
                      </p>
                    </div>
                    <h4 className="font-semibold text-gray-900 text-sm mt-2">
                      General
                    </h4>
                    {generalPagesData.map((item, index) => (
                      <a
                        key={index}
                        href={item.link}
                        className="flex items-center text-gray-700 hover:text-gray-500"
                        onClick={toggleMobileMenu}
                      >
                        {item.name}{" "}
                        <FaArrowRight className="-rotate-45 ml-auto w-4 h-4 text-gray-400" />
                      </a>
                    ))}
                    {/* <h4 className="font-semibold text-gray-900 text-sm mt-2">Maintenance</h4>
                  {maintenancePagesData.map((item, index) => (
                    <a key={index} href={item.link} className="flex items-center text-gray-700 hover:text-gray-500" onClick={toggleMobileMenu}>{item.name} <FaArrowRight className="-rotate-45 ml-auto w-4 h-4 text-gray-400"/></a>
                  ))} */}
                    <h4 className="font-semibold text-gray-900 text-sm mt-2">
                      External
                    </h4>
                    {externalPagesData.map((item, index) => (
                      <a
                        key={index}
                        href={item.link}
                        className="flex items-center text-gray-700 hover:text-gray-500"
                        onClick={toggleMobileMenu}
                      >
                        {item.name}{" "}
                        <FaArrowRight className="-rotate-45 ml-auto w-4 h-4 text-gray-400" />
                      </a>
                    ))}
                  </div>
                )}
              </div>

              {}
              <a
                href="/documentation"
                className="flex items-center justify-between w-full text-gray-600 hover:text-gray-700 font-medium text-lg py-2 border-b border-gray-100"
                onClick={toggleMobileMenu}
              >
                Docs
                <FaArrowUpRightFromSquare className="ml-1 h-5 w-5" />
              </a>

              {}
              <button
                className="mt-4 bg-[#1a9588] text-white px-6 py-3 rounded-full font-medium hover:bg-[#28b5a6] transition duration-150 ease-in-out w-full"
                onClick={toggleMobileMenu}
              >
                Become To Seller
              </button>
            </nav>
          </div>
        )}
      </header>
    </div>
  );
};

export default Header;
